module.exports = __webpack_public_path__ + "static/wood-2275415077cf0db2a12ef0c1057654a1.jpg";